import { FilteredCreditApplication } from '@applyonline/shared'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '../../../services/trackingEvents'
import { ETrackedEvents } from '../../../types/tracking'

interface Props {
  creditApp: FilteredCreditApplication
}

const DeclinedDecisionPage = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  useEffect(() => {
    trackEvent(ETrackedEvents.QualifDeclined, creditApp)
  }, [creditApp])

  return (
    <main
      className="general-message"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem 1rem',
      }}
    >
      <h4 className="subtitle">{t('common.financeApplication')}</h4>
      <p
        className="black-strong"
        style={{
          fontSize: 20,
          margin: 0,
          textAlign: 'center',
        }}
      >
        {t(`finalDecision.refused`)}
      </p>
    </main>
  )
}

export default DeclinedDecisionPage
